"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (Chat$) { return function () {
    return Chat$.getState().session || {};
}; });
//# sourceMappingURL=getSession.js.map